import { Container } from 'reactstrap'
import s from './DetailsForm.scss'
import { Tabs } from 'components/ideal-core-ui'
import { PaginatedSelect } from 'components/common/PaginatedSelect'
import { toDealsSelect } from './serializers'
import { AddDealForm } from './AddDealForm'

const DetailsForm = ({ setSelectedDeal, selectedDeal }) => {
  return (
    <Container>
      <p className={s.description}>
        The template you selected uses placeholders for client and project information. Please fill
        out the form below to generate the proposal.
      </p>
      <h6>Opportunity/Project Information</h6>
      <Tabs
        className={s.tabContainer}
        noPadding
        activeTabKey={selectedDeal?.type ?? 'existing'}
        tabs={[
          {
            key: 'existing',
            label: 'Select Existing Opportunity',
            cb: () => setSelectedDeal(() => null),
            value: (
              <PaginatedSelect
                className={s.select}
                url="/v1/deals"
                onChange={value =>
                  setSelectedDeal(() => ({
                    type: 'existing',
                    value
                  }))
                }
                serializer={toDealsSelect}
                value={selectedDeal?.type === 'existing' ? selectedDeal?.value : null}
              />
            )
          },
          {
            key: 'new',
            label: 'Create New Opportunity/Project',
            cb: () => setSelectedDeal(() => null),
            value: <AddDealForm setSelectedDeal={setSelectedDeal} selectedDeal={selectedDeal} />
          }
        ]}
      />
    </Container>
  )
}

export default DetailsForm
